/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_Comm_LiftInputs */

const cs_clients_comm_lift = /** @type {(inputs: Clients_Comm_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zrušit`)
};

const en_clients_comm_lift = /** @type {(inputs: Clients_Comm_LiftInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lift`)
};

/**
* | output |
* | --- |
* | "Lift" |
*
* @param {Clients_Comm_LiftInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const clients_comm_lift = /** @type {((inputs?: Clients_Comm_LiftInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_Comm_LiftInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_comm_lift(inputs)
	return cs_clients_comm_lift(inputs)
});